import {useAiContext} from '@/biz/ai'
import {ButtonImportModel as _ButtonImportModel} from '@/biz/ai/chat'

export default function ButtonImportModel({wfMap, shortToLong, updateWfMap, ...props}) {
    const ai = useAiContext()
    const message = ai.lastMessage

    const onClick = async () => {
        const aiOutput = message.content;
        // 移除think部分（think可能出现在响应中的任何位置）
        const withoutThink = aiOutput.replace(/<think>[\s\S]*?<\/think>/gi, '')
        
        // 查找markdown JSON代码块（支持```json和```）
        const jsonBlockRegex = /```(?:json)?\s*([\s\S]*?)\s*```/;


        const match = withoutThink.match(jsonBlockRegex);
        if(match) {
            try {
                // const json = JSON.parse(match[match.length - 1]);
                const aiResult = JSON.parse(match[match.length - 1]);
                updateWfMap(aiResult);
            } catch (error) {
                console.error('JSON解析错误：', error);
                message.error('JSON解析错误：', error);
            }
        }
    }

    return (
        <_ButtonImportModel
            onClick={onClick}
            {...props}
        />
    )
}
